import React from 'react';
import { useAuth } from './session';

interface Props {
  /** Capability key to check — if true, render whenAllowed; otherwise whenDenied */
  capability: string;
  whenAllowed: React.ComponentType<any>;
  whenDenied:  React.ComponentType<any>;
}

export default function RoleSwitch({ capability, whenAllowed: Allowed, whenDenied: Denied }: Props) {
  const { capabilities } = useAuth();
  const ok = capabilities.isSuperadmin === true || capabilities[capability] === true;
  const Component = ok ? Allowed : Denied;
  return <Component />;
}